import React, {useState, useCallback} from 'react';
import {compose} from 'recompose';

import {connect} from 'react-redux';
import {Segment, Label, Icon, Button, Message} from 'semantic-ui-react';
import {FilePond, registerPlugin} from "react-filepond";
import {hot} from 'react-hot-loader';

import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

const MAX_FILES = 30;
const UPLOAD_TIMEOUT = 3e4;
const IMAGE_TARGET_SIZE = 1440;

registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImageResize, FilePondPluginImagePreview, FilePondPluginImageTransform);

const ReportUpload = ({report, invokeChange, throwError, user, online}) => {
    const [uploadFiles, setUploadFiles] = useState([]);

    const serverConfig = {
        url: '/api/images',
        timeout: UPLOAD_TIMEOUT,
        process: {
            url: '/UploadAttachment',
            method: 'POST',
            headers: {'Authorization': `${user.auth.token_type} ${user.auth.token}`},
            onload: null,
            onerror: null,
            ondata: (data) => {
                const [meta, file] = data.getAll('filepond');

                const formData = new FormData();
                formData.append('TrainingEventID', report.id);
                formData.append('ImageFieldName', file.name);
                formData.append('ImageBuffer', file);
                return formData;
            }
        },
        load: null,
        fetch: null
    }

    if (isNaN(report.id) || !online) {
        return (
            <Message color='yellow'>
                <Message.Header>Unable to upload</Message.Header>
                <p>
                    Cannot Upload Files for Reports created in Offline Mode.
                    Save the Report to upload Files
                </p>
            </Message>
        )
    }
    if (report.mobileUpload) {
        return (
            <div>
                <Segment>
                    <FilePond
                        files={uploadFiles}
                        allowMultiple={true}
                        server={serverConfig}
                        onupdatefiles={setUploadFiles}
                        labelIdle={'Upload Files'}
                        maxFiles={MAX_FILES}
                        imageResizeTargetWidth={IMAGE_TARGET_SIZE}
                    />
                </Segment>
            </div>
        );
    } else {
        return (
            <div></div>
        );
    }

}

export default compose(
    connect(({auth}) => ({
        user: auth.user,
    })),
    hot(module),
)(ReportUpload);




